module.exports = __webpack_public_path__ + "img/gh.dadb2611.svg";